import Cookies from 'js-cookie';
import _get from 'lodash/get';
var api = Cookies.withAttributes({
  secure: typeof window !== 'undefined' && _get(window, 'location.protocol') === 'https:',
  sameSite: 'lax'
});
export var $cookie = api;